export interface Tq7SlowSteamingM {
  propellerPitch: string;
  propellerDiameter: string;
  mainEngineMakerModel: string;
  engineTuning: string;
  noxTierIIIComplianceMethod: string;
  mainEngineMCRRating: string;
  engineEquippedWithPowerLimited: string;
  mainEngineLimitedPowerRating: string;
  mainEngineRpmAtLimitedPower: string;
  mainEngineSMCRRating: string;
  mainEngineNCR: string;
  SMCRRating: string;
  ncrBallast: string;
  ncrLaden: string;
  minSlowSMCR: string;
  blocminSlowSteamingEngine: string;
  criticalRPMUpper: string;
  criticalRPMLower: string;
  minUltraSlowSMCR: string;
  minUltraSlowStreamingRPM: string;
  auxBlowersCutOFF: string;
  auxBlowersPressure: string;
  isTheVesselFitted: string;
  energySavingDevicesRemarks: string;
}

export const tq7SlowSteamingFormInit = {
  propellerPitch: " ",
  propellerDiameter: " ",
  mainEngineMakerModel: " ",
  engineTuning: " ",
  noxTierIIIComplianceMethod: "",
  mainEngineMCRRating: " ",
  engineEquippedWithPowerLimited: " ",
  mainEngineLimitedPowerRating: " ",
  mainEngineRpmAtLimitedPower: " ",
  mainEngineSMCRRating: " ",
  mainEngineNCR: " ",
  SMCRRating: " ",
  ncrBallast: " ",
  ncrLaden: " ",
  minSlowSMCR: " ",
  blocminSlowSteamingEngine: " ",
  criticalRPMUpper: " ",
  criticalRPMLower: " ",
  minUltraSlowSMCR: " ",
  minUltraSlowStreamingRPM: " ",
  auxBlowersCutOFF: " ",
  auxBlowersPressure: " ",
  isTheVesselFitted: " ",
  energySavingDevicesRemarks: "",
};

export function mapSqlToTq7SlowSteamingForm(_slowSteaming: any): Tq7SlowSteamingM {
  return {
    propellerPitch: _slowSteaming.PROPELLER_PITCH,
    propellerDiameter: _slowSteaming.PROPELLER_DIAMETER,
    mainEngineMakerModel: _slowSteaming.MAIN_ENGINE_MAKER_MODEL,
    engineTuning: _slowSteaming.ENGINE_TUNING,
    noxTierIIIComplianceMethod: _slowSteaming.NOX_TIER_III_COMPLIANCE_METHOD ?? "",
    mainEngineMCRRating: _slowSteaming.MAIN_ENGINE_MCR_RATING,
    engineEquippedWithPowerLimited: _slowSteaming.ENGINE_EQUIPPED_WITH_POWER_LIMITED,
    mainEngineLimitedPowerRating: _slowSteaming.MAIN_ENGINE_LIMITED_POWER_RATING,
    mainEngineRpmAtLimitedPower: _slowSteaming.MAIN_ENGINE_RPM_LIMITED_POWER,
    mainEngineSMCRRating: _slowSteaming.MAIN_ENGINE_SMCR_RATING,
    mainEngineNCR: _slowSteaming.MAIN_ENGINE_NCR,
    SMCRRating: _slowSteaming.SMCR_RATING,
    ncrBallast: _slowSteaming.NCR_BALLAST,
    ncrLaden: _slowSteaming.NCR_LADEN,
    minSlowSMCR: _slowSteaming.MIN_SLOW_SMCR,
    blocminSlowSteamingEngine: _slowSteaming.BLOCMINSLOW_STEAMING_ENGINE,
    criticalRPMUpper: _slowSteaming.CRITICAL_RPM_UPPER,
    criticalRPMLower: _slowSteaming.CRITICAL_RPM_LOWER,
    minUltraSlowSMCR: _slowSteaming.MIN_ULTRA_SLOW_SMCR,
    minUltraSlowStreamingRPM: _slowSteaming.MIN_ULTRA_SLOW_STREAMING_RPM,
    auxBlowersCutOFF: _slowSteaming.AUX_BLOWERS_CUT_OFF,
    auxBlowersPressure: _slowSteaming.AUX_BLOWERS_PRESSURE,
    isTheVesselFitted: _slowSteaming.IS_THE_VESSEL_FITTED,
    energySavingDevicesRemarks: _slowSteaming.ENERGY_SAVING_DEVICES_REMARKS ?? "",
  };
}
